/**
 * TEST: PDP-011 — et-cta-banner live Trustpilot score (Proof 3).
 * <et-tp-score data-business-unit-id hidden> fetches the genuine current
 * store score from the Trustpilot trustbox-data endpoint (same source as
 * et-trustpilot-reviews.js) and fills the {score} placeholder in the child
 * [data-et-tp-template] element. The item only becomes visible when a real
 * score loaded — nothing is ever hardcoded and fetch failures keep it hidden.
 */
(function () {
  'use strict';

  if (customElements.get('et-tp-score')) return;

  var TEMPLATE_ID = '5419b732fbfb950b10de65e5';

  class EtTpScore extends HTMLElement {
    connectedCallback() {
      var businessUnitId = this.dataset.businessUnitId;
      var target = this.querySelector('[data-et-tp-template]');
      if (!businessUnitId || !target) return;

      var url =
        'https://widget.trustpilot.com/trustbox-data/' + TEMPLATE_ID +
        '?businessUnitId=' + encodeURIComponent(businessUnitId) +
        '&locale=' + encodeURIComponent(document.documentElement.lang || 'nl-NL');

      var self = this;
      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('Trustpilot HTTP ' + response.status);
          return response.json();
        })
        .then(function (data) {
          var unit = data && data.businessUnit;
          var score = unit && (unit.trustScore || (unit.score && unit.score.trustScore));
          if (!score) return;
          var formatted = Number(score).toLocaleString('nl-NL', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
          });
          target.textContent = (target.dataset.etTpTemplate || '{score}').replace('{score}', formatted);
          self.hidden = false;
        })
        .catch(function () {
          /* keep the item hidden — never show an unverified score */
        });
    }
  }

  customElements.define('et-tp-score', EtTpScore);
})();
